module.exports = __webpack_public_path__ + "static/media/workout.52d54f13.svg";